import React from 'react'
import { Trans } from '@lingui/react'
import SVGInline from 'react-svg-inline'

import urlFor, { QueryParams } from 'shared/tools/url-helper'

import { SerialProps } from 'client/shared/types/serial'
import { SeriesProps } from 'client/shared/types/series'
import Linka from 'client/shared/blocks/linka'
import ProgressiveCover from 'client/shared/blocks/progressive-cover/progressive-cover'
import { BookCover } from 'client/shared/blocks/book-cover/book-cover'
import PlayIcon from 'client/shared/icons/play.svg'
import Chevron from 'client/shared/icons/chevron-right.svg'

import './book-link.styl'

type Props = {
  item: SerialProps | SeriesProps
  kind: 'serial' | 'series'
  query?: QueryParams
}

export const BookLink: React.FC<Props> = ({ kind, item, query }) => {
  const { cover, title, uuid } = item
  const isSerial = kind === 'serial'

  const height = 84
  const coverStyle = { width: '84px', height: '84px' }

  return (
    <Linka
      path={isSerial ? urlFor.serial(uuid, query) : urlFor.series(uuid, query)}
    >
      <div className="link__wrapper">
        {isSerial ? (
          <BookCover book={item} size={88} isLeadCover />
        ) : (
          <div
            className="series-cover__wrapper series-cover__audiobook"
            style={coverStyle}
          >
            <div className="series-cover__substrate" />
            <SVGInline svg={PlayIcon} className="series-cover__play-icon" />
            <ProgressiveCover
              src={cover.large}
              placeholder={cover.placeholder || ''}
              width={height}
              height={height}
              alt={title}
            />
          </div>
        )}
        <div className="link__text">
          <span className="link__offer">
            <Trans
              id={isSerial ? 'book.you_can_read' : 'book.you_can_listen'}
            />
          </span>
          <span className="link__title">{title}</span>
        </div>
        <SVGInline className="link__chevron" svg={Chevron} />
      </div>
    </Linka>
  )
}
